import $ from 'jquery';

const TARGET = 'body';
const CLASS = 'u-disable-scroll';

const $target = $(TARGET);

$.on('store/app-scroll/enable', function() {
    const scrollY = parseInt($target.css('top'));

    $target
        .data('disable-scroll', false)
        .removeClass(CLASS)
        .css('top', 'unset');

    window.scrollTo(0, (scrollY || '0') * -1);
});

$.on('store/app-scroll/disable', function() {
    const scrollY = window.scrollY

    $target
        .data('disable-scroll', true)
        .addClass(CLASS)
        .css('top', `-${scrollY}px`);
});

$.on('store/app-scrolltoggle', function() {

    const action = $target.data('disable-scroll') ? 'enable' : 'disable';

    $.trigger(`store/app-scroll${action}`);

});
